

































import Vue from 'vue'
import { carSeasonsController } from '~/api/RentalCar'
import AppView from '~/components/AppView.vue'
import DateTimePicker from '~/components/DateTimePicker.vue'
import { TableHeader } from '~/utils/interfaces'
import { CarSeason } from '~/utils/interfaces/rentalCar'
export default Vue.extend({
  components: { AppView, DateTimePicker },
  data() {
    return {
      controller: carSeasonsController,
      headers: [
        {
          text: this.$t('name'),
          value: 'name',
        },
        {
          text: this.$t('start_datetime'),
          value: 'start_datetime',
        },
        {
          text: this.$t('end_datetime'),
          value: 'end_datetime',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ] as TableHeader<CarSeason>[],
      defaultCrud: {
        name: '',
        start_datetime: '',
        end_datetime: '',
        description: '',
      },
    }
  },
})
